var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 182,
    viewBox: "0 0 361 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.719 181.134L360.86 90.992L270.719 0.863281V181.134Z",
    fill: "#E20613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4453 0.863281L180.587 90.992L270.716 0.863281H90.4453Z",
    fill: "#E20613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4453 181.136H270.716L180.587 90.9941L90.4453 181.136Z",
    fill: "#E20613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 90.992L90.4529 181.134V0.863281L0.324219 90.992Z",
    fill: "#E20613"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogHero);
export default __webpack_public_path__ + "static/media/mobile-log-hero.8644dc68983dfc0ba511c53af6600a23.svg";
export { ForwardRef as ReactComponent };